/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Jumbotron } from 'reactstrap'

export const Index: React.FunctionComponent = () => {
	return (
		<div>
			<nav aria-label="breadcrumb">
				<ol className="breadcrumb">
					<li className="breadcrumb-item active" aria-current="page">
						<NavLink to="/"> Home </NavLink>
					</li>
				</ol>
			</nav>
			<Jumbotron>
				<h1 className="display-4">Index / landing page</h1>
				<p className="lead">Insurance Discovery</p>
			</Jumbotron>
		</div>
	)
}
